import { marked } from 'marked';

const EMPTY_PARAGRAPH = /<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi;

/**
 * Render markdown to sanitized HTML for the chat text-part renderer.
 *
 * GFM + line-break extension enabled. Trailing empty `<p>` tags (common with the
 * `breaks: true` setting on inputs ending in blank lines) are stripped.
 */
export function processMarkdown(text: string): string {
  const html = String(marked.parse(text, { async: false, gfm: true, breaks: true }));
  return html.replace(EMPTY_PARAGRAPH, '');
}
